<p-accordionTab>
    <p-header>
        <div class="ui-helper-clearfix">
            <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Roaming Detection Configuration (AT+GTRMD)</span>
            </div>
        </div>
    </p-header>

    <div class="ui-g">
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Main Settings</span>
                        </div>
                    </div>
                </p-header>

                <div class="col row dvcFields">
                    <div class="col lblStyle">
                        <form-input fieldName="Mode">
                        </form-input>
                    </div>
                    <div class="col">
                        <div class="ui-inputgroup">
                            <p-dropdown [options]="modeOptions" [(ngModel)]="rmdParameters.mode"
                                [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
        </div>
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Mask Settings</span>
                        </div>
                    </div>
                </p-header>
                <div class="row align-items-center">
                    <form-input fieldName="Known Roaming Event Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPNA" [(ngModel)]="rmdParameters.knownMaskRESPGTPNA">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPFA" [(ngModel)]="rmdParameters.knownMaskRESPGTPFA">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTMPN" [(ngModel)]="rmdParameters.knownMaskRESPGTMPN">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTMPF" [(ngModel)]="rmdParameters.knownMaskRESPGTMPF">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTBPL" [(ngModel)]="rmdParameters.knownMaskRESPGTBPL">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTBTC" [(ngModel)]="rmdParameters.knownMaskRESPGTBTC">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTC" [(ngModel)]="rmdParameters.knownMaskRESPGTSTC">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTT" [(ngModel)]="rmdParameters.knownMaskRESPGTSTT">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPDP" [(ngModel)]="rmdParameters.knownMaskRESPGTPDP">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTRTL" [(ngModel)]="rmdParameters.knownMaskRESPGTRTL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition report +RESP:GTIGN/GTIGF/GTVGN/GTVGF" [(ngModel)]="rmdParameters.knownMaskRESPGTIGNGTIGFGTVGNGTVGF">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition on location report +RESP:GTIGL/GTVGL" [(ngModel)]="rmdParameters.knownMaskRESPGTIGLGTVGL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTIGS" [(ngModel)]="rmdParameters.knownMaskRESPGTIGS">
                            </p-checkbox>
                        </div>
                        <div class="col">
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <form-input fieldName="Unknown Roaming Event Mask"></form-input>
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPNA" [(ngModel)]="rmdParameters.unknownMaskRESPGTPNA">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPFA" [(ngModel)]="rmdParameters.unknownMaskRESPGTPFA">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTMPN" [(ngModel)]="rmdParameters.unknownMaskRESPGTMPN">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTMPF" [(ngModel)]="rmdParameters.unknownMaskRESPGTMPF">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTBPL" [(ngModel)]="rmdParameters.unknownMaskRESPGTBPL">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTBTC" [(ngModel)]="rmdParameters.unknownMaskRESPGTBTC">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTC" [(ngModel)]="rmdParameters.unknownMaskRESPGTSTC">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTSTT" [(ngModel)]="rmdParameters.unknownMaskRESPGTSTT">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTPDP" [(ngModel)]="rmdParameters.unknownMaskRESPGTPDP">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTRTL" [(ngModel)]="rmdParameters.unknownMaskRESPGTRTL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition report +RESP:GTIGN/GTIGF/GTVGN/GTVGF" [(ngModel)]="rmdParameters.unknownMaskRESPGTIGNGTIGFGTVGNGTVGF">
                            </p-checkbox>
                        </div>
                        <div class="col">
                            <p-checkbox binary="true" label="Ignition on location report +RESP:GTIGL/GTVGL" [(ngModel)]="rmdParameters.unknownMaskRESPGTIGLGTVGL">
                            </p-checkbox>
                        </div>
                    </div>       
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        <div class="col">
                            <p-checkbox binary="true" label="+RESP:GTIGS" [(ngModel)]="rmdParameters.unknownMaskRESPGTIGS">
                            </p-checkbox>
                        </div>
                        <div class="col">
                        </div>
                    </div>       
                </div>                
            </p-accordionTab>
        </div>    

        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Home Operator List</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">
                    <div class="col row dvcFields">
                            <div class="col lblStyle">
                                <form-input fieldName="Home Operator Start">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                    <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.homeOperatorStart" [min]="1" [max]="10"></p-spinner>
                                    <span class="ui-inputgroup-addon">1~10</span>
                                </div>
                            </div>
                    </div>
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Home Operator End">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.homeOperatorEnd" [min]="1" [max]="10"></p-spinner>
                                <span class="ui-inputgroup-addon">1~10</span>
                            </div>
                        </div>
                    </div>              
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 1">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode1" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 2">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode2" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 3">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode3" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 4">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode4" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 5">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode5" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 6">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode6" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 7">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode7" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 8">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode8" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 9">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode9" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 10">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.homeCode10" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                
                </div>
            </p-accordionTab>
        </div>
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Roaming Operator List</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">
                    <div class="col row dvcFields">
                            <div class="col lblStyle">
                                <form-input fieldName="Roaming Operator Start">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                    <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.roamingOperatorStart" [min]="1" [max]="100"></p-spinner>
                                    <span class="ui-inputgroup-addon">1~100</span>
                                </div>
                            </div>
                    </div>
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Roaming Operator End">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.roamingOperatorEnd" [min]="1" [max]="100"></p-spinner>
                                <span class="ui-inputgroup-addon">1~100</span>
                            </div>
                        </div>
                    </div>              
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 1">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode1" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 2">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode2" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 3">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode3" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 4">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode4" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 5">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode5" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 6">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode6" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 7">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode7" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 8">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode8" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 9">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode9" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 10">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode10" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 11">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode11" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 12">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode12" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 13">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode13" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 14">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode14" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 15">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode15" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 16">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode16" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 17">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode17" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 18">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode18" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 19">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode19" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 20">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode20" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 21">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode21" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 22">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode22" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 23">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode23" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 24">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode24" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 25">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode25" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 26">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode26" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 27">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode27" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 28">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode28" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 29">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode29" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 30">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode30" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 31">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode31" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 32">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode32" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 33">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode33" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 34">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode34" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 35">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode35" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 36">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode36" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 37">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode37" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 38">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode38" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 39">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode39" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 40">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode40" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 41">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode41" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 42">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode42" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 43">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode43" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 44">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode44" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 45">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode45" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 46">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode46" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 47">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode47" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 48">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode48" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 49">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode49" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 50">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode50" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 51">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode51" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 52">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode52" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 53">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode53" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 54">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode54" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 55">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode55" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 56">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode56" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 57">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode57" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 58">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode58" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 59">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode59" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 60">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode60" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 61">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode61" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 62">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode62" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 63">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode63" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 64">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode64" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 65">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode65" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 66">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode66" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 67">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode67" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 68">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode68" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 69">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode69" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 70">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode70" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 71">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode71" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 72">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode72" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 73">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode73" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 74">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode74" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 75">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode75" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 76">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode76" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 77">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode77" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 78">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode78" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 79">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode79" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 80">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode80" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 81">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode81" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 82">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode82" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 83">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode83" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 84">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode84" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 85">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode85" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 86">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode86" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 87">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode87" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 88">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode88" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 89">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode89" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 90">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode90" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 91">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode91" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 92">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode92" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 93">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode93" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 94">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode94" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 95">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode95" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 96">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode96" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 97">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode97" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 98">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode98" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 99">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode99" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 100">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.roamingCode100" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>
            </p-accordionTab>
        </div>
        <div class="ui-g-12">
            <p-accordionTab [selected]="true">
                <p-header>
                    <div class="ui-helper-clearfix">
                        <div class="left">
                            <span class="ui-panel-title"
                                style="font-size:16px;display:inline-block;margin-top:2px">Black Operator List</span>
                        </div>
                    </div>
                </p-header>

                <div class="row align-items-center">
                    <div class="col row dvcFields">
                            <div class="col lblStyle">
                                <form-input fieldName="Black Operator Start">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                    <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.blackOperatorStart" [min]="1" [max]="20"></p-spinner>
                                    <span class="ui-inputgroup-addon">1~20</span>
                                </div>
                            </div>
                    </div>
                    <div class="col row dvcFields">
                        <div class="col lblStyle">
                            <form-input fieldName="Black Operator End">
                            </form-input>
                        </div>
                        <div class="col">
                            <div class="ui-inputgroup">
                                <p-spinner size="5" step="1" [(ngModel)]="rmdParameters.blackOperatorEnd" [min]="1" [max]="20"></p-spinner>
                                <span class="ui-inputgroup-addon">1~20</span>
                            </div>
                        </div>
                    </div>              
                </div>
                <div class="row align-items-center">
                    <div class="col row dvcFields">
                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 1">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode1" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 2">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode2" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 3">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode3" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>  
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 4">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode4" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 5">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode5" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>    
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 6">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode6" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 7">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode7" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 8">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode8" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 9">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode9" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 10">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode10" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 11">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode11" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 12">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode12" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 13">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode13" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 14">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode14" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 15">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode15" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>
                    <div class="col row dvcFields">                        
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 16">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode16" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 17">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode17" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 18">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode18" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 19">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode19" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col lblStyle">
                                <form-input fieldName="Code 20">
                                </form-input>
                            </div>
                            <div class="col">
                                <div class="ui-inputgroup">
                                  <input type="text" pInputText [(ngModel)]="rmdParameters.blackOperatorCode20" maxlength="6" class="txtbStyle" />
                                </div>
                              </div>
                        </div> 
                    </div>                  
                </div>               
            </p-accordionTab>
        </div>
    </div>
</p-accordionTab>